var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrxdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.125 10.038c-1.407-1.299-3.352-3.281-4.936-4.688l-.095-.065a1.79 1.79 0 0 0-.52-.29C20.755 4.281 2.975.957 2.628 1a.656.656 0 0 0-.272.104l-.089.07c-.11.111-.193.246-.244.394L2 1.628v.386c2.002 5.573 9.905 23.83 11.46 28.115.094.29.273.844.606.872h.075c.179 0 .938-1.003.938-1.003s13.575-16.462 14.948-18.215a4.43 4.43 0 0 0 .469-.694 1.13 1.13 0 0 0-.37-1.05zM18.56 11.955l5.794-4.805 3.399 3.131-9.192 1.675zm-2.25-.314L6.337 3.467l16.139 2.977-6.164 5.198zm.9 2.143 10.21-1.645L15.748 26.2l1.463-12.417zM4.982 4.282l10.496 8.906-1.518 13.021L4.98 4.281z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrxdown);
export default __webpack_public_path__ + "static/media/TRXDOWN.815633dbe6e2a86c3209e35dba4f6e3d.svg";
export { ForwardRef as ReactComponent };